import React from 'react'

import { useAppTheme } from '@flowwai-frontend/bps-officer-web/style-guide'
import { Button, Hierarchy, SubVariant } from '@flowwai-frontend/design-system'
import { RefreshCCW01Icon } from '@flowwai-frontend/design-system/icons'
import { useCustomT } from '@flowwai-frontend/shared/common-components'

interface Props {
   onRetry: () => void
}

const GSErrorView = (props: Props): React.ReactElement => {
   const t = useCustomT('globalSearch:searchModal')
   const { theme } = useAppTheme()
   const { retryIconColor } = theme.globalSearch.searchModal

   return (
      <Button
         hierarchy={Hierarchy.Secondary}
         subVariant={SubVariant.GrayOutline}
         size={'Small'}
         onClick={props.onRetry}
         leftIcon={() => <RefreshCCW01Icon fill={retryIconColor} />}
      >
         {t('retryBtnText')}
      </Button>
   )
}

export default GSErrorView
